import React, { useState, useContext, useEffect } from "react";
import {
  Modal,
  Select,
  Button,
  Steps,
  List,
  Input,
  message,
  Tooltip,
  Form,
  DatePicker,
} from "antd";
import moment from "moment";
import "moment/locale/es";
import { PlanCuidadoContext } from "../../../context/PlanCuidadoContextProvider";
import CustomTable from "../../CustomTable";
import { plusicon } from "../../imagepath";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { extractPatientIdFromUrl } from "../../../utils/helpers";
import { post } from "../../../services/base";
import { GestoresContext } from "../../../context/GestoresContext";
import { obtenerMetas } from "../../../services/dim";

import {
  actividadesCode,
  tipoActividades,
} from "../../../utils/enums/statusCodes";
import {
  ExclamationCircleFilled,
  CloseCircleOutlined,
} from "@ant-design/icons";
import {
  actualizarEstatusActividad,
  crearActividades,
} from "../../../services/actividades";
import {procedenciasCode} from "../../../utils/enums/statusCodes";

const { Option } = Select;
const { Step } = Steps;

const Citas = () => {
  const { planesCuidadoData, updatePlanesCuidadoData, planesCuidadoOpciones } =
    useContext(PlanCuidadoContext);
  const { gestores } = useContext(GestoresContext);
  const [selectedPlanAsociado, setSelectedPlanAsociado] = useState(null);
  const [selectedCita, setSelectedCita] = useState(null);
  const [selectedResponsable, setSelectedResponsable] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [citasListado, setCitasListado] = useState([]);
  const [modalProgramarVisible, setModalProgramarVisible] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [fechaLimite, setFechaLimite] = useState(null);
  const [meta, setMeta] = useState("");
  const [metas, setMetas] = useState([]);
  const allCitas = planesCuidadoData
    ? planesCuidadoData.reduce((acc, plan) => acc.concat(plan.citas || []), [])
    : [];
  const [selectedGestor, setSelectedGestor] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedHour, setSelectedHour] = useState(null);
  const [lugarCita, setLugarCita] = useState("");
  const [descripcionCita, setDescripcionCita] = useState("");
  const [notificarPaciente, setNotificarPaciente] = useState(true);
  const [selectedCitaId, setSelectedCitaId] = useState(null);
  const [citasForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadingProgramar, setLoadingProgramar] = useState(false);

  moment.locale("es");

  const [formData, setFormData] = useState({
    examen: "",
    fechaToma: null,
  });

  const handleFechaLimite = (date, dateString) => {
    setFechaLimite(dateString);
  };

  const handleCerrarAgregarCita = () => {
    const form = document.getElementById("citasForm");

    setModalVisible(false);
    setLoading(false);
  };

  const handlePlanSelection = async (value, label) => {
    setSelectedPlanAsociado(value);
    try {
      const response = await post(
        "/PlanesCuidado/actividades/listado",
        JSON.stringify({ descripcion: label.children, tipo: "2" })
      );
      const data = response.data[0];

      const formattedData = {
        citas: data.citas.map((cita) => ({
          id: cita.codigo,
          descripcion: cita.descripcion,
          fecha: cita.fecha,
          tipoActividad: cita.tipoActividad,
        })),
      };

      setCitasListado(formattedData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const metas = await obtenerMetas();
        console.log(metas);
        setMetas(metas);

      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const handleModalProgramarCancel = () => {
    setModalProgramarVisible(false);
    setCurrentStep(0);
  };

  const handleGuardarClick = async () => {
    try {
      setLoadingProgramar(true);
      const fechaSeleccionada = selectedDate || moment().format("YYYY-MM-DD");
      const [horaInicio, horaFin] = selectedHour.split(" - ");

      const horaInicioSinAmPm = horaInicio.replace(/\s(a|p)m$/i, "");
      const horaFinSinAmPm = horaFin.replace(/\s(a|p)m$/i, "");

      const dataToSend = {
        idCita: selectedCitaId.id,
        gestor: selectedGestor,
        fecha: fechaSeleccionada,
        hora: `${horaInicioSinAmPm}-${horaFinSinAmPm}`,
        lugar: lugarCita,
        descripcion: descripcionCita,
        notificar: notificarPaciente,
        afiliado: extractPatientIdFromUrl(),
      };

      var response = await post(
        "/PlanesCuidado/cita/programar",
        JSON.stringify(dataToSend)
      );
      if (response.data) message.success("Cita programada exitosamente.");
      updatePlanesCuidadoData();
      setLoadingProgramar(false);
      setModalProgramarVisible(false);
    } catch (error) {
      setLoadingProgramar(false);
      console.error("Error programando cita:", error);
      message.error(
        "Error programando cita. Por favor, inténtelo de nuevo más tarde."
      );
    }
  };

  const handleSiguientePasoClick = () => {
    if (currentStep === 3) {
      setModalProgramarVisible(false);
      setCurrentStep(0);
    } else {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleCompletarClick = async (cita) => {
    try {
      const { confirm } = Modal;
      confirm({
        title: "Actualización Estado Actividad",
        icon: <ExclamationCircleFilled />,
        centered: true,
        content:
          "¿Está seguro que desea actualizar la cita del paciente a completa?",
        okText: "Si",
        cancelText: "No",
        onOk() {
          return new Promise((resolve, reject) => {
            actualizarEstatusActividad(cita.id, {
              estatus: actividadesCode.Finalizada.value,
            }).then(() => {
              updatePlanesCuidadoData();
              resolve();
            });
          }).catch(() => console.log("Oops errors!"));
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancelarClick = async (cita) => {
    try {
      const { confirm } = Modal;
      confirm({
        title: "Actualización Estado Actividad",
        icon: <ExclamationCircleFilled />,
        content: "¿Está seguro que desea cancelar la cita del paciente?",
        okText: "Si",
        cancelText: "No",
        onOk() {
          return new Promise((resolve, reject) => {
            actualizarEstatusActividad(cita.id, {
              estatus: actividadesCode.Cancelada.value,
            }).then(() => {
              updatePlanesCuidadoData();
              resolve();
            });
          }).catch(() => console.log("Oops errors!"));
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleAgregarCita = async () => {
    citasForm
      .validateFields()
      .then(async (values) => {
        if (
          values != undefined &&
          values.errorFields != undefined &&
          values.errorFields.length > 0
        ) {
          message.error("Los campos marcados son requeridos");
          setLoading(false);
          return;
        } else {
          try {
            setLoading(true);
            const data = [
              {
                codigoActividad: selectedCita.value.toString(),
                descripcionActividad: selectedCita.label,
                codigoMeta: meta.value,
                responsable: selectedResponsable,
                fechaLimite: moment(fechaLimite).format("YYYY-MM-DD"),
                meta: "",
              },
            ];
            await crearActividades(selectedPlanAsociado, data);
            message.success("Actividad agregada exitosamente.");
            updatePlanesCuidadoData();
            handleCerrarAgregarCita();
          } catch (error) {
            console.error("Error agregando actividad:", error);
            message.error(
              "Error al agregar actividad. Por favor, inténtelo de nuevo más tarde."
            );
          }
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  const handleAsignarClick = (hora) => {
    setSelectedHour(hora);
    setCurrentStep(currentStep + 1);
  };

  const handleSelectedGestor = (record) => {
    setSelectedGestor(record);
  };

  const handleButtonClick = (record) => {
    const { actividadDe, responsable } = record;

    Modal.info({
      title: "Informacion adicional",
      content: (
        <div>
          <p>
            <strong>Meta:</strong> {actividadDe}
          </p>
          <p>
            <strong>Fuente:</strong> {responsable}
          </p>
          <p>
            <strong>Responsable:</strong> {responsable}
          </p>
        </div>
      ),
      onOk() {},
      centered: true,
    });
  };

  const handleProgramarClick = (citaId) => {
    setSelectedCitaId(citaId);
    setModalProgramarVisible(true);
    setCurrentStep(0);
  };


  const columns = [
    {
      title: "Consulta",
      dataIndex: "actividadDe",
      key: "actividadDe",
      sorter: (a, b) => a.actividadDe.localeCompare(b.actividadDe),
      searchable: true,
    },
    {
      title: "Programa Asociado",
      dataIndex: "planAsociado",
      key: "planAsociado",
      sorter: (a, b) => a.planAsociado.localeCompare(b.planAsociado),
      searchable: true,
    },
    {
      title: "Estatus",
      dataIndex: "estatus",
      key: "estatus",
      sorter: (a, b) => a.estatus.localeCompare(b.estatus),
      searchable: true,
    },
    {
      title: "Acción",
      dataIndex: "accion",
      key: "accion",
      render: (text, record) => {
        if (record.estatus == actividadesCode.Programado.text) {
          return (
            <Button
              type="link"
              className="btn btn-danger"
              style={{ backgroundColor: "#0d6efd", borderColor: "#0d6efd" }}
              onClick={() => handleCompletarClick(record)}
            >
              Finalizar
            </Button>
          );
        } else if (record.estatus == actividadesCode.Activa.text) {
          return (
            <Button
              type="link"
              className="btn btn-primary"
              style={{
                backgroundColor: "var(--mint-green)",
                borderColor: "var(--mint-green)",
              }}
              onClick={() => handleProgramarClick(record)}
            >
              Programar
            </Button>
          );
        } else {
          return;
        }
      },
    },
    {
      title: "Adicional",
      dataIndex: "adicional",
      key: "adicional",
      render: (text, record) => (
        <Button
          type="link"
          className="btn btn-primary"
          style={{
            backgroundColor: "var(--mint-green)",
            borderColor: "var(--mint-green)",
          }}
          onClick={() => handleButtonClick(record)}
        >
          Informacion adicional
        </Button>
      ),
    },
    {
      title: "Fecha Limite",
      dataIndex: "fechaLimite",
      key: "fechaLimite",
      sorter: (a, b) => a.fechaLimite.localeCompare(b.fechaLimite),
      searchable: true,
    },
    {
      title: "Fecha Agendamiento",
      dataIndex: "fechaAgendamiento",
      key: "fechaAgendamiento",
      sorter: (a, b) => a.fechaAgendamiento.localeCompare(b.fechaAgendamiento),
      searchable: true,
    },
    {
      title: "",
      dataIndex: "cancelar",
      key: "cancelar",
      render: (text, record) => {
        if (
          record.estatus == actividadesCode.Activa.text ||
          record.estatus == actividadesCode.Programado.text
        ) {
          return (
            <Tooltip title="Cancelar cita">
              <Button
                type="link"
                style={{ color: "rgb(255, 153, 153)" }}
                onClick={() => handleCancelarClick(record)}
              >
                <CloseCircleOutlined />
              </Button>
            </Tooltip>
          );
        } else {
          return null;
        }
      },
    },
  ];

  const rowSelection = {
  };

  // Contenido de cada paso del wizard
  const stepsContent = [
    <div style={{ marginTop: "40px" }}>
      <Select
        placeholder="Selecciona al gestor responsable"
        isClearable
        onChange={(gestor) => handleSelectedGestor(gestor)}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
            "&:hover": {
              borderColor: state.isFocused
                ? "none"
                : "2px solid rgba(46, 55, 164, 0.1)",
            },
            borderRadius: "10px",
            fontSize: "14px",
            minHeight: "45px",
          }),
          dropdownIndicator: (base, state) => ({
            ...base,
            transform: state.selectProps.menuIsOpen
              ? "rotate(-180deg)"
              : "rotate(0)",
            transition: "250ms",
            width: "35px",
            height: "35px",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 10000,
          }),
        }}
        components={{
          IndicatorSeparator: () => null,
        }}
        options={
          gestores
            ? gestores.map((gestor) => ({
                value: gestor.usuarioId,
                label: gestor.gestor,
              }))
            : []
        }
      />
    </div>,
    <div style={{ display: "flex", marginTop: "40px" }}>
      <div style={{ flex: 1, marginRight: "50px", height: "200px" }}>
        <Calendar
          initialView="dayGridMonth"
          locale="es"
          selectable={true}
          onChange={(date) => setSelectedDate(date)}
        />
      </div>
      <div style={{ flex: 1, overflowY: "auto", maxHeight: "300px" }}>
        <List
          bordered
          dataSource={Array.from({ length: 18 }).map((_, index) => {
            const hour = Math.floor(index / 2) + 8;
            const minute = index % 2 === 0 ? "00" : "30";
            const nextHour = index % 2 !== 0 ? hour + 1 : hour;
            const nextMinute = index % 2 === 0 ? "30" : "00";
            const ampm1 = hour < 12 ? "am" : "pm";
            const ampm2 = nextHour < 12 ? "am" : "pm";
            const formattedHour1 =
              hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
            const formattedHour2 =
              nextHour === 0 ? 12 : nextHour > 12 ? nextHour - 12 : nextHour;
            return {
              hora: `${String(formattedHour1).padStart(
                2,
                "0"
              )}:${minute} ${ampm1} - ${String(formattedHour2).padStart(
                2,
                "0"
              )}:${nextMinute} ${ampm2}`,
            };
          })}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button
                  key="asignar"
                  onClick={() => handleAsignarClick(item.hora)}
                >
                  Asignar
                </Button>,
              ]}
            >
              {item.hora}
            </List.Item>
          )}
        />
      </div>
    </div>,
    <div style={{ marginTop: "40px" }}>
      <div style={{ marginBottom: "10px" }}>
        <label htmlFor="lugarCita">Lugar de la cita</label>
        <Input id="lugarCita" onChange={(e) => setLugarCita(e.target.value)} />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label htmlFor="descripcionCita">Descripción de la cita</label>
        <Input
          id="descripcionCita"
          onChange={(e) => setDescripcionCita(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label htmlFor="notificarPaciente">Notificar al paciente?</label>
        <Select
          id="notificarPaciente"
          defaultValue={notificarPaciente ? "true" : "false"}
          onChange={(value) =>
            setNotificarPaciente(value === "true" ? true : false)
          }
        >
          <Option value={"true"}>Si</Option>
          <Option value={"false"}>No</Option>
        </Select>
      </div>
    </div>,
  ];

  const stepsTitles = [
    "Seleccione responsable",
    "Seleccione fecha de la cita",
    "Ingrese ubicación",
  ];

  return (
    <div className="card">
      <div className="card-header pb-0">
        <h4 className="card-title d-inline-block">Consultas</h4>{" "}
      </div>
      <CustomTable
        dataSource={allCitas}
        columns={columns}
        contexto={procedenciasCode.Actividad.value}
        updateDataSource={updatePlanesCuidadoData || []}
      />{" "}
      {/* Agrega tus columnas */}
      <Button
        className="btn btn-primary add-pluss ms-2"
        onClick={() => setModalVisible(true)}
      >
        <img src={plusicon} alt="#" />
        Agregar
      </Button>
      <Modal
        title="Disponibilidad de agenda"
        open={modalProgramarVisible}
        onCancel={handleModalProgramarCancel}
        footer={[
          <Button key="cancel" onClick={handleModalProgramarCancel}>
            Cancelar
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={loadingProgramar}
            onClick={
              currentStep === 2 ? handleGuardarClick : handleSiguientePasoClick
            }
          >
            {currentStep === 2 ? "Guardar" : "Siguiente"}
          </Button>,
        ]}
        centered
        width="40%"
      >
        <Steps current={currentStep}>
          {stepsTitles.map((title) => (
            <Step key={title} title={title} />
          ))}
        </Steps>
        {stepsContent[currentStep]}
      </Modal>
      <Modal
        title="Agregar consulta"
        open={modalVisible}
        onCancel={handleCerrarAgregarCita}
        footer={[
          <Button key="cancel" onClick={handleCerrarAgregarCita}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleAgregarCita}
          >
            Agregar
          </Button>,
        ]}
        centered
        style={{
          zIndex: 1042,
        }}
      >
        <div className="row">
          <div className="col-sm-12">
            <br></br>
            <Form form={citasForm}>
              <div className="row">
                <div className="col-12 col-md-6 col-xl-12">
                  <div className="form-group local-forms">
                    <label>
                      Estrategia asociada <span className="login-danger">*</span>
                    </label>
                    <Form.Item
                      name={"Estrategia asociada"}
                      rules={[{ required: true, message: "Es requerido" }]}
                    >
                      <Select
                        id="buscar-plan-asociado"
                        style={{ width: "100%" }}
                        value={selectedPlanAsociado}
                        onChange={(value, label) =>
                          handlePlanSelection(value, label)
                        }
                      >
                        {planesCuidadoOpciones &&
                          planesCuidadoOpciones.length > 0 &&
                          planesCuidadoOpciones.map((plan) => (
                            <Option key={plan.value} value={plan.value}>
                              {plan.label}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-8">
                    <div className="form-group local-forms">
                      <label>
                        Consulta <span className="login-danger">*</span>
                      </label>
                      <Form.Item
                        name={"Actividad"}
                        rules={[{ required: true, message: "Es requerida" }]}
                      >
                        <Select
                          id="buscar-plan-asociado"
                          onChange={(value, option) =>
                            setSelectedCita({
                              value: value,
                              label: option.children,
                            })
                          }
                          style={{ width: "100%" }}
                        >
                          {citasListado.citas &&
                            citasListado.citas.length > 0 &&
                            citasListado.citas.map((cita) => (
                              <Option key={cita.id} value={cita.id}>
                                {cita.descripcion}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-xl-4">
                    <div className="form-group local-forms">
                      <label>
                        Responsable <span className="login-danger">*</span>
                      </label>
                      <Form.Item name={"Responsable"}>
                        <Select
                          id="buscar-responsable"
                          defaultValue={selectedResponsable}
                          onChange={setSelectedResponsable}
                          style={{ width: "100%" }}
                        >
                          {gestores &&
                            gestores.length > 0 &&
                            gestores.map((gestor) => (
                              <Option
                                key={gestor.usuarioId}
                                value={gestor.usuarioId}
                              >
                                {gestor.gestor}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12">
                <div className="form-group local-forms">
                    <label>
                    Meta <span className="login-danger">*</span>
                    </label>
                    <Form.Item
                      name={"Meta"}
                      rules={[{ required: true, message: "Es requerida" }]}
                    >
                      <Select
                        id=""
                        onChange={(value, option) =>
                          setMeta({
                            value: value,
                            label: option.children,
                          })
                        }
                        style={{ width: "100%" }}
                      >
                        {metas &&
                          metas.length > 0 &&
                          metas.map((meta) => (
                            <Option key={meta.value} value={meta.value}>
                              {meta.label}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-xl-12">
                  <div className="form-group local-forms cal-icon">
                    <label>
                      Fecha límite <span className="login-danger">*</span>
                    </label>
                    <Form.Item
                      name={"Fecha límite"}
                      rules={[{ required: true, message: "Es requerida" }]}
                    >
                      <DatePicker
                        className="form-control datetimepicker"
                        onChange={handleFechaLimite}
                        placeholder=""
                        suffixIcon={null}
                      />
                    </Form.Item>
                    {/* <input
                                              className="form-control datetimepicker"
                                              type="text"
                                          /> */}
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Citas;
